import { normalizeCourseName } from './normalizeCourseName'

export default function getNormalizedCourseName(typeParam: string, careerName: string ) {
    const courseName = typeParam || careerName || ''
    return normalizeCourseName(courseName)
}